
import { computed, SetupContext } from 'vue'

export default {
  name: 'Pager',

  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 1
    },
    rowCnt: {
      type: Number,
      default: 15
    }
  },

  setup(props: any, context: SetupContext) {
    // 最大表示するページ数
    const maxShowLength = 5

    // 最大ページ数
    const totalPageLength = computed(() => {
      let len = Math.floor(props.totalCount / props.rowCnt)
      len += props.totalCount % props.rowCnt > 0 ? 1 : 0
      return len
    })

    const pagerArr = computed(() => {
      const arr = []
      let startPage = 0
      let endPage = 0

      if (totalPageLength.value <= maxShowLength) {
        startPage = 1
        endPage = totalPageLength.value
      } else {
        const pagerBeforeAfterLength = (maxShowLength - 1) / 2 // 現在地の前後に表示するナビの数
        startPage = props.pageNum - pagerBeforeAfterLength // 開始するナビの番号
        endPage = props.pageNum + pagerBeforeAfterLength // 終了するナビの番号

        // 開始ナビの番号が1以下になった場合は後ナビをその分増やす
        if (startPage < 1) {
          const diff = -(startPage - 1)
          endPage += diff
          startPage = 1
        }

        // 終了ナビの番号が最大以上になった場合は前ナビをその分増やす
        if (endPage > totalPageLength.value) {
          const diff = endPage - totalPageLength.value
          startPage -= diff
          endPage = totalPageLength.value
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        arr.push(i)
      }

      return arr
    })

    // 前のページに遷移するボタンを表示するか
    const hasPrevPage = computed(() => {
      return totalPageLength.value > 1 && props.pageNum > 1 ? true : false
    })

    // 次のページに遷移するボタンを表示するか
    const hasNextPage = computed(() => {
      return totalPageLength.value > 1 && props.pageNum < totalPageLength.value
        ? true
        : false
    })

    const clickPagerBtn = (num: number) => {
      context.emit('move-page', num)
    }

    return {
      hasPrevPage,
      hasNextPage,
      pagerArr,
      totalPageLength,
      clickPagerBtn
    }
  }
}
